import { render, staticRenderFns } from "./FlightItemCard.vue?vue&type=template&id=c1611cb0&scoped=true&"
import script from "./FlightItemCard.vue?vue&type=script&lang=js&"
export * from "./FlightItemCard.vue?vue&type=script&lang=js&"
import style0 from "./FlightItemCard.vue?vue&type=style&index=0&id=c1611cb0&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1611cb0",
  null
  
)

export default component.exports